module.exports = __webpack_public_path__ + "img/iconMode.cae9af53.svg";